// extracted by mini-css-extract-plugin
export default {"fullWidth":"filters_fullWidth__Sh4xV"};